import { render, staticRenderFns } from "./TabTable.vue?vue&type=template&id=44b158cc&scoped=true&"
import script from "./TabTable.vue?vue&type=script&lang=ts&"
export * from "./TabTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b158cc",
  null
  
)

export default component.exports